"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get FLAG_SLUGS () {
        return FLAG_SLUGS;
    },
    get FeatureFlagModel () {
        return FeatureFlagModel;
    }
});
const _zod = require("zod");
const FLAG_SLUGS = [
    "autoflow",
    "ff-config-engagement-manual-reminder-timeout-period",
    "ff-config-max-automated-review-cycles",
    "ff-config-is-verbose-ingest-engine-logging-enabled",
    "ff-engagement-email-provider",
    "ff-in-app-promotions-enabled",
    "ff-is-ai-enabled",
    "ff-is-calendar-integration-enabled",
    "ff-is-company-org-chart-enabled",
    "ff-is-directory-enabled",
    "ff-is-document-signing-enabled",
    "ff-is-enabled-custom-fields-in-document-signing",
    "ff-is-enabled-enforce-login-methods",
    "ff-is-engagement-survey-enabled",
    "ff-engagement-only",
    "ff-is-enabled-microsoft-teams-integration",
    "ff-is-feedback-enabled",
    "ff-is-enabled-sftp-integration",
    "ff-is-enabled-recognition-slack-notifications",
    "ff-is-goal-overview-and-alignment-enabled",
    "ff-is-goals-enabled",
    "ff-is-groups-enabled",
    "ff-is-enabled-api-key",
    "ff-is-ip-whitelisting-enabled",
    "ff-is-in-app-referrals-enabled",
    "ff-is-manager-and-contributor-reporting-access-enabled",
    "ff-is-meetings-enabled",
    "ff-is-reporting-visualizations-enabled",
    "ff-is-resources-enabled",
    "ff-is-reviews-enabled",
    "ff-is-saml-enabled",
    "ff-is-scim-enabled",
    "ff-is-surveys-enabled",
    "ff-is-three-sixty-reviews-enabled",
    "ff-is-workflows-enabled",
    "ff-temp-ai-assisted-form-question-authoring",
    "ff-temp-archive-goals-internal-api",
    "ff-temp-goal-bulk-create",
    "ff-temp-goals-workers",
    "ff-temp-is-contributor-reporting-enabled",
    "flag-with-category",
    "license-tier",
    "reporting-visuals",
    "session-replays",
    "ff-current-promotion",
    "ff-is-teams-user-notifications-enabled",
    "ff-is-conversational-ui-enabled",
    "ff-temp-survey-reports-in-reporting-analytics-phase-one",
    "ff-temp-is-engagement-question-selection-enabled",
    "ff-temp-survey-reports-in-reporting-analytics-phase-two"
];
const FeatureFlagModel = _zod.z.object({
    _id: _zod.z.enum(FLAG_SLUGS),
    name: _zod.z.string(),
    type: _zod.z.enum([
        "boolean",
        "number",
        "string"
    ]),
    description: _zod.z.string(),
    tags: _zod.z.array(_zod.z.string()),
    initial_value: _zod.z.union([
        _zod.z.boolean(),
        _zod.z.number(),
        _zod.z.string()
    ]),
    created_at: _zod.z.date()
});
